import { reactive } from 'vue';

export const activeMenus = reactive({
  menus: {},
  setAllMenusAsInactive() {
    for (const key in this.menus) {
      this.menus[key] = false;
    }
  },
  setActiveMenu(menuName) {
    switch (menuName) {
      case 'vehicle-request':
        this.menus['trip-request'] = true;
        break;
      case 'vehicle-request-details-id':
        this.menus['trip-request'] = true;
        break;
      case 'backup-request':
        this.menus['trip-request'] = true;
        break;
      case 'trip-create':
        this.menus['trip-request'] = true;
        break;
      case 'trip-details-id':
        this.menus['trip-request'] = true;
        break;
      case 'backup-details-id':
        this.menus['trip-request'] = true;
        break;
      case 'partners-profile-id':
        this.menus['partners'] = true;
        break;
      case 'service-partners':
        this.menus['assigned-partners'] = true;
        break;
      case 'partners-bill-view':
        this.menus['partners-attendance'] = true;
        break;
      case 'partners-disbursement-view':
        this.menus['partners-attendance'] = true;
        break;
      case 'partners-disbursement-view-details':
        this.menus['partners-attendance'] = true;
        break;
      case 'partner-custom-permission-list':
        this.menus['partner-permission-list'] = true;
        break;
      case 'trip-request-form':
        this.menus['trip-create'] = true;
        break;

      default:
        this.menus[menuName] = true;
        break;
    }

    if (menuName == 'city-settings' || menuName == 'area-settings') {
      this.menus['locations'] = true;
      this.menus['settings'] = true;
    }

    if (
      menuName == 'car-type-settings' ||
      menuName == 'car-brand-settings' ||
      menuName == 'trip-type-settings' ||
      menuName == 'preset-remarks-settings' ||
      menuName == 'call-notes-settings' ||
      menuName == 'promo-banner-settings' ||
      menuName == 'promotional-video-settings' ||
      menuName == 'email-template-settings' ||
      menuName == 'holiday-calendar-settings'
    ) {
      this.menus['settings'] = true;
    }
  }
});
